import { render, staticRenderFns } from "./AllRanking.vue?vue&type=template&id=5028e0e8&scoped=true&"
import script from "./AllRanking.vue?vue&type=script&lang=js&"
export * from "./AllRanking.vue?vue&type=script&lang=js&"
import style0 from "./AllRanking.vue?vue&type=style&index=0&id=5028e0e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028e0e8",
  null
  
)

component.options.__file = "AllRanking.vue"
export default component.exports